<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="HconsultoriosPsicologicos">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>CONSULTORIOS PSICOLÓGICOS</h1>
                    <p>Los consultorios de psicología de la Fundación Best son atendidos por psicólogos clínicos egresados de diversas Universidades, con especialidades y/ o  posgrados en la materia.  Ellos están calificados para brindar psicología clínica a todo paciente que lo necesite.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
</div>

<div class="mapContainer">
    
            <div class="container">
                <div class="">
                    <div class="posicion-busq-map">
                        <div class="cont-busq-map">
                            <div class="color-busq-map">
                                
                                <form class="flx flx-width">
                                    <div class="agenda-cita">
                                        <div class="content-agenda">
                                            <div class="">
                                                <div class="bloq-img"><img src="./assets/images/ico-agenda-cita.svg"></div>
                                            </div>
                                            <div class="bloq-text">
                                                <p id="costo">Costo $180</p>
                                                <div class="subr-text">
                                                    <p>Agenda tu cita en los<br> teléfonos de cada Unidad</p>
                                                </div>
                                                <p id="p-servicio"><small><strong>*Servicio Gratis</strong> los primeros dos meses <br>de apertura en cada unidad.</small></p>
                                            </div>
                                        </div>
                                    </div> 
                                     
                                <div class="select-map">
                                        <label>ESTADO</label>
                                        <select [(ngModel)]="estadoId" name="estadoId"
                                                (ngModelChange)="getCiudades($event)"
                                                class="form-control" required>
                                            <option [ngValue]="''" selected>Seleccione Estado</option>
                                            <option *ngFor="let estado of estados" [ngValue]="estado.idestado">
                                                {{ estado.nombre | uppercase }}
                                            </option>
                                        </select>
                                </div>

                                <div class="select-map">
                                        <label>MUNICIPIO O ALCALDÍA</label>
                                        <select [(ngModel)]="ciudadSeleccionada" name="ciudadId"
                                                (ngModelChange)="selectCiudad($event)"
                                                class="form-control" required>
                                            <option [ngValue]="''" selected>Seleccione un Municipio o Alcaldía</option>
                                            <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad">
                                                {{ ciudad.nombre | uppercase }}
                                            </option>
                                        </select>
                                </div>
                            </form>
                            
                            </div>
                            
                        </div>
                        
                    </div>
                    
                </div>
                <div class="infoBox" *ngIf="infoConsultorio">
                    <div class="listsucursales" *ngFor="let c of infoConsultorio">
                        <p><strong>Sucursal:</strong> {{ c.consultorio }}</p>
                        <p><strong>Teléfono:</strong> {{ c.telefono }}</p>
                        <p><strong>Dirección:</strong> {{ c.direccion }}</p>
                        <p><strong>Horario:</strong> {{ c.horario }}</p>
                    </div>
                </div>
                

               

                <!-- SI NO HAY RESULTADOS -->
                <div class="dDiez dmDoce FtbRst flx" *ngIf="dont">
                    <p>Por el momento no tenemos cobertura en su zona</p>
                </div>

                <div class="espacioDefault"></div>

                <!-- 🔽 AQUÍ SÍ VA EL MAPA -->
                <div id="Fmap">
                    <div class="map-cover"></div>
                </div>
            </div>
</div>
